import { useEffect } from 'react';
import { Button, Form, Input } from 'antd';
import classnames from 'classnames/bind';
import { cloneDeep } from 'lodash-es';
import { AntdGarbageDetection } from '@yaotai/components';
import { BUSINESS_TYPE, GarbageDetectionForm } from '@commonPackage/constants';
import { CountryPhoneFieldFormItem } from '@commonPackage/components';
import { checkInternationalPhone, emailReg } from '@portalCommon/utils';
import type { RecommendFormData } from '@portalCommon/type';
import { useSessionStorageState } from '@fuxi/eevee-hooks';
import API from '@/services';
import { BaseModal, ModalCommonType } from '.';
import styles from './index.module.less';

const cx = classnames.bind(styles);

// 填写信息表单
export function RecommendFormModal(props: ModalCommonType) {
  const { onClose } = props;
  const [recommendSession, setRecommendSession] = useSessionStorageState('RECOMMEND', {});
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(recommendSession);
  }, []);

  const onFinish = async (value: RecommendFormData) => {
    const params: Record<string, any> = cloneDeep(value);
    params.phone = `+${value.phone.code}${value.phone.phone}`;
    params.email = params.email ? params.email : undefined;

    const { data } = await API.recommend.referrer(params);

    const saveData = {
      ...value,
      code: data.code,
    };

    setRecommendSession(saveData);

    onClose(value);
  };

  return (
    <BaseModal onClose={onClose} confirmClose>
      <div className={cx('recommend-form')}>
        <h6 className={cx('modal-title')}>填写你的信息，即可成为推荐官</h6>
        <p className={cx('modal-tip')}>请认真填写以下信息，以便我们进行奖励发放。</p>
        <Form
          className={cx('recommend-form-content')}
          form={form}
          labelCol={{ span: 6 }}
          labelAlign="right"
          onFinish={onFinish}>
          <AntdGarbageDetection
            form={form}
            request={(info: GarbageDetectionForm) => API.activity.getGarbageDetection({ ...info, need_detail: false })}
            name="name"
            type={BUSINESS_TYPE.TEXT}
            render={(validator, detectionEvent) => (
              <Form.Item
                label="姓名"
                name="name"
                rules={[{ validator }, { required: true, whitespace: true, max: 20 }]}>
                <Input
                  placeholder="请输入您的姓名"
                  onBlur={e => {
                    detectionEvent(e);
                  }}
                />
              </Form.Item>
            )}></AntdGarbageDetection>
          <CountryPhoneFieldFormItem
            labelAlign="right"
            labelName="手机号"
            form={form}
            validateTrigger={[]}
            placeholder="请输入联系方式"
            rules={[
              {
                required: true,
                validator: checkInternationalPhone(true, '请输入正确的手机号'),
              },
            ]}
          />
          <Form.Item label="邮箱" name="email" rules={[{ max: 64, pattern: emailReg, message: '请输入正确的邮箱' }]}>
            <Input placeholder="请输入您的邮箱" type="email" />
          </Form.Item>
          <AntdGarbageDetection
            form={form}
            request={(info: GarbageDetectionForm) => API.activity.getGarbageDetection({ ...info, need_detail: false })}
            name="organization"
            type={BUSINESS_TYPE.TEXT}
            render={(validator, detectionEvent) => (
              <Form.Item
                label="组织/公司"
                name="organization"
                rules={[{ validator }, { required: true, whitespace: true, max: 50 }]}>
                <Input
                  placeholder="请输入您的组织/公司"
                  onBlur={e => {
                    detectionEvent(e);
                  }}
                />
              </Form.Item>
            )}></AntdGarbageDetection>
          <Form.Item>
            <Button type="primary" htmlType="submit" className={cx('submit-btn')}>
              下一步
            </Button>
          </Form.Item>
        </Form>
      </div>
    </BaseModal>
  );
}
